import React, { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  Avatar,
  useMediaQuery,
  Button,
  InputAdornment,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import FilterListIcon from "@mui/icons-material/FilterList";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import moment from "moment";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import CustomDrawer from "../../components/layouts/CustomDrawer";
import JobsFilter from "./JobsFilter";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CompanyPopup from "../../components/popUp/CompanyPopup";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import UpgradeModal from "../../components/popUp/UpgradeModal";
import {
  addCommasToNumber,
  formatEducationRequired,
} from "../../utils/Constant";
import { FormControl } from "react-bootstrap";
import JobPostDescription from "./components/JobPostDescription";
import SkeletonLoader from "../../components/loader/SkeletonLoader";
import PostJobHeader from "../post/PostJobHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import JobListCard from "../../components/jobs/JobListCard";
import { useIds } from "../../hook/AdminContext";
import CustomModalLayout from "../../components/modal/CustomModalLayout";
import { filter_blue_icon, search_blue_icon } from "../../assets";
import CustomPagination from "../../components/CustomPagination/CustomPagination";

export default function JobFeedList({
  isTablet,
  categories,
  setCategories = () => {},
  loading,
  appliedFilters,
  renderFilterChips,
  handleFilterClear,
  scrollRef,
  lastBookElementRef,
  loadMoreData,
  isLoadingMore,
  totalPages,
  pageNumber,
  handleOpenDetail,
  handleCompanyNameClick,
  s3baseUri,
  userInfo,
  bookmarkedJobs,
  handleBookmarkToggle,
  MENU_OPTIONS,
  handlePersonalJob,
  handleOpen,
  handleNavigateAppliedJobs,
  filterDrawerOpen,
  handleFilterDrawerClose,
  fetchCategories,
  filterValues,
  applyFilters,
  handleFilterChange,
  handleRemoveFilterChip,
  companyModalOpen,
  handleCloseCompanyModal,
  companyModalData,
  openDetail,
  cv,
  selectedJob,
  selectedFilterFav,
  setCv,
  handleCloseDetail,
  open,
  handleClose,
  editMode,
  sourceId,
  openUpgradeModal,
  setOpenUpgradeModal,
  openRenewConfirm,
  setOpenRenewConfirm,
  handleRenewJob,
  renewJobId,
  PostJobModalProps,
  PostJobDetailProps,
  CompanyPopupProps,
  CustomConfirmationProps,
  load_more_path,
  searchTerm,
  findId,
  searchInputValue,
  handleInputChange,
  handleFilterDrawerOpen,
  show_des_data,
  handleCandidates,
  setIsHovered,
  deleteDialogOpen,
  handleDeleteMember,
  setDeleteDialogOpen,
  deletingMemberId,
  pageTitle,
  isMyJobPost,
  isFavourite,
  filteredData = [],
  selectedFilter = "",
  sourceSlug,
}) {
  const { GetAccessOfCompany, setUpdateJobOnNotification } = useIds();
  const navigate = useNavigate();
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean); // split and remove empty
  const lastSegment = segments[segments.length - 1];
  const params = useParams();
  // const sourceSlug = params?.source_slug ? params?.source_slug : "";
  const jobTypeSlug = params?.jobtype_slug ? params?.jobtype_slug : "";
  const isLiveJobFeed = jobTypeSlug
    ? location.pathname == `/${params.source_slug}/${jobTypeSlug}` ||
      location.pathname == `/jobs/${jobTypeSlug}`
    : false;

  let isMobile = window.innerWidth < 768;
  let isTabletOrAbove = window.innerWidth >= 768;

  // Update on resize
  window.addEventListener("resize", () => {
    isMobile = window.innerWidth < 768;
    isTabletOrAbove = window.innerWidth >= 768;
  });

  const handleMoveToSettings = () => {
    if (params.source_slug) {
      navigate(`/${params.source_slug}/${params.jobtype_slug}/job-settings`);
    } else {
      navigate(`/job-settings`);
    }
  };

  const handleNavigateJobAlerts = () => {
    if (params.source_slug) {
      navigate(`/${params.source_slug}/${params.jobtype_slug}/job-alerts`);
    }
  };

  return (
    <>
      <CustomConfirmation
        open={openRenewConfirm}
        setOpen={setOpenRenewConfirm}
        headerHeading="Renew Job"
        title="Are you sure you want to renew this job?"
        handleAgree={() => {
          handleRenewJob(renewJobId);
        }}
      />

      <UpgradeModal
        open={openUpgradeModal}
        handleClose={() => setOpenUpgradeModal(false)}
      />

      <CustomModalLayout
        open={open}
        onClose={handleClose}
        title={editMode ? "Update Job" : "Post Job"}
        width="850px"
        componentToPass={
          <PostJobHeader
            refreshlist={fetchCategories}
            loadMorePath={load_more_path}
            searchTerm={searchTerm}
            loadingstate={loading}
            id={findId}
            open={open}
            handleClose={handleClose}
            editMode={editMode}
            jobData={selectedJob}
            sourceId={sourceId}
            sourceSLug={sourceSlug}
          />
        }
      />

      <CompanyPopup
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
      />
      <PostJobDetail
        cv={cv}
        open={openDetail}
        setCv={setCv}
        job={selectedJob}
        handleClose={handleCloseDetail}
      />
      {isTablet ? (
        <div className="container-fluid px-2">
          <div className="row">
            <div className="mb-4 col-12">
              <div className="card-body main-heading-live-jobs jobs-live-main">
                <h3 className="ml-4">{pageTitle}</h3>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
                  <div className="d-flex flex-column flex-sm-row gap-2 w-100 w-md-auto">
                    <Box
                      display="flex"
                      gap={1}
                      width="100%"
                      flexDirection={{ xs: "column", sm: "row" }}
                    >
                      <div className="custom-input-design">
                        <div className="position-relative">
                          <input
                            className="ps-5"
                            placeholder={"Search..."}
                            value={searchInputValue}
                            onChange={handleInputChange}
                          />

                          <img
                            src={search_blue_icon}
                            className="input-start-icon"
                            alt=""
                          />
                        </div>
                      </div>

                      {isFavourite === true && filteredData?.length > 0 && (
                        <TextField
                          select
                          label="Filter by Source"
                          value={selectedFilter || ""}
                          onChange={(e) => handleFilterChange(e)}
                          size="small"
                          sx={{ minWidth: 200 }}
                        >
                          {filteredData.map((item) => (
                            <MenuItem key={item?._id} value={item?._id}>
                              {item?.title}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    </Box>

                    {isLiveJobFeed && (
                      <button
                        className="small-button-contain-job-live"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}
                        onClick={handleFilterDrawerOpen}
                        type="button"
                      >
                        <FilterListIcon
                          style={{ fontSize: 20, marginRight: 4 }}
                        />
                        Filter
                      </button>
                    )}

                    {(userInfo?.role === "client" ||
                      userInfo?.isCompanyProfile) &&
                      isMyJobPost === false && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handlePersonalJob}
                          >
                            My Job Posts
                          </button>
                        </>
                      )}
                    {(GetAccessOfCompany("job?.add") ||
                      GetAccessOfCompany("job?.update")) &&
                      isMyJobPost == true && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleMoveToSettings}
                          >
                            Job Settings
                          </button>
                        </>
                      )}
                    {((userInfo?.role === "client" &&
                      !userInfo?.isCompanyProfile) ||
                      (userInfo?.isCompanyProfile &&
                        userInfo?.company_access?.job?.add)) &&
                      isMyJobPost === false && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={() => {
                              // navigate(`/${sourceSlug}/post-new-job`);
                              handleOpen();
                            }}
                          >
                            <PostAddOutlinedIcon className="post-add-icon" />
                            Post Job
                          </button>
                        </>
                      )}
                    {userInfo?.role === "candidate" &&
                      sourceSlug &&
                      !userInfo?.isCompanyProfile &&
                      isFavourite === false && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleNavigateJobAlerts}
                          >
                            <NotificationsNoneIcon
                              style={{
                                fontSize: "18px",
                                color: "#fff",
                              }}
                            />{" "}
                            Job Alerts
                          </button>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleNavigateAppliedJobs}
                          >
                            <CheckCircleOutlineIcon
                              style={{
                                fontSize: "18px",
                                color: "#fff",
                              }}
                            />{" "}
                            Applied Jobs
                          </button>
                        </>
                      )}
                  </div>
                </div>

                {loading ? (
                  <div className="mt-3 px-3">
                    <SkeletonLoader />
                  </div>
                ) : categories?.length === 0 ? (
                  <div
                    className="px-3"
                    // style={{ height: "1000px", overflowY: "auto" }}
                  >
                    <RecordNotFound title="No jobs" />
                  </div>
                ) : (
                  <div
                    ref={scrollRef}
                    className="px-3"
                    // style={{ height: "1000px", overflowY: "auto" }}
                  >
                    {categories.map((job, index) => (
                      <div
                        key={index}
                        className=""
                        onClick={(e) => handleOpenDetail(job, e)}
                      >
                        {/* <div className="d-flex">
                          <div
                            style={{
                              width: 60,
                              height: 60,
                              borderRadius: "50%",
                              overflow: "hidden",
                              marginRight: 12,
                            }}
                          >
                            {job?.created_by?.profile_image?.thumbnail_1 ? (
                              <img
                                onClick={(e) => handleCompanyNameClick(job, e)}
                                src={
                                  s3baseUri +
                                  job.created_by.profile_image?.thumbnail_1
                                }
                                alt="Logo"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <div
                                onClick={(e) => handleCompanyNameClick(job, e)}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {job.created_by?.company_name && "Logo"}
                              </div>
                            )}
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  marginRight: "8px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <h5
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "calc(100% - 40px)",
                                    }}
                                  >
                                    {job.job_title}
                                  </h5>
                                </div>
                                <p
                                  onClick={(e) =>
                                    handleCompanyNameClick(job, e)
                                  }
                                  style={{
                                    margin: "4px 0",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  className="company-name"
                                >
                                  {job.created_by?.company_name}
                                </p>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-end",
                                }}
                              >
                                {job.created_by?._id === userInfo?._id && (
                                  <div onClick={(e) => e.stopPropagation()}>
                                    <CustomPopoverSection
                                      menu={MENU_OPTIONS.map((option) => ({
                                        ...option,
                                        disabled: option.getDisabled
                                          ? option.getDisabled(job)
                                          : false,
                                        tooltip: option.getTooltip
                                          ? option.getTooltip(job)
                                          : "",
                                      }))}
                                      data={job}
                                    />
                                  </div>
                                )}
                                {userInfo.role === "candidate" && (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleBookmarkToggle(job?._id);
                                    }}
                                    size="small"
                                    style={{ padding: "4px" }}
                                  >
                                    {job.is_favourite ? (
                                      <BookmarkIcon
                                        style={{
                                          color: "var(--portal-primary-color)",
                                          fontSize: "20px",
                                        }}
                                      />
                                    ) : (
                                      <BookmarkBorderIcon
                                        style={{ fontSize: "20px" }}
                                      />
                                    )}
                                  </IconButton>
                                )}
                              </div>
                            </div>

                            <div
                              style={{
                                margin: "3px 0",
                                fontSize: "13px",
                                color: "#555",
                              }}
                            >
                              <>
                                <span
                                  className="me-3 d-block d-md-inline cursor-pointer"
                                  style={{ fontSize: "14px" }}
                                >
                                  <i
                                    className="far fa-calendar-alt  me-2"
                                    style={{
                                      color: "var(--portal-primary-color)",
                                    }}
                                  />
                                  {new Date(job.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )}
                                </span>
                              </>

                              <span
                                className="me-3 d-block d-md-inline cursor-pointer"
                                style={{ fontSize: "14px" }}
                              >
                                <i
                                  className="fa fa-map-marker-alt  me-2"
                                  style={{
                                    color: "var(--portal-primary-color)",
                                  }}
                                />
                                {job.location}
                              </span>

                              <span
                                className="d-block d-md-inline cursor-pointer"
                                style={{ fontSize: "14px" }}
                              >
                                <i
                                  className="far fa-money-bill-alt  me-2"
                                  style={{
                                    color: "var(--portal-primary-color)",
                                  }}
                                />
                                {job.salary_type === "fixed" ? (
                                  <>€{addCommasToNumber(job.salary)}</>
                                ) : (
                                  <>
                                    €{addCommasToNumber(job.min_salary)} - €
                                    {addCommasToNumber(job.max_salary)}
                                  </>
                                )}
                                {job.frequency_salary && (
                                  <>
                                    {" / "}
                                    {{
                                      Monthly: "Month",
                                      Daily: "Day",
                                      Weekly: "Week",
                                      Hourly: "Hour",
                                      Anually: "Annually",
                                    }[job.frequency_salary] ||
                                      job.frequency_salary}
                                  </>
                                )}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "8px",
                              }}
                            >
                              {job?.created_by?._id === userInfo?._id &&
                                userInfo?.role === "client" && (
                                  <div
                                    className="position-relative d-flex justify-content-end w-100"
                                    style={{
                                      width: "max-content",
                                    }}
                                  >
                                    <div
                                      className="badge position-absolute"
                                      style={{
                                        top: "-1px",
                                        right: "-4px",
                                        backgroundColor: "#FF0000",
                                        color: "#fff",
                                        padding: "2px 6px",
                                        borderRadius: "12px",
                                        minWidth: "20px",
                                        textAlign: "center",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                      }}
                                    >
                                      {job?.job_applicants?.length || 0}
                                    </div>
                                    <button
                                      onClick={() => handleCandidates(job)}
                                      className="small-button-contain-job"
                                    >
                                      Candidates
                                    </button>
                                  </div>
                                )}
                              {userInfo?._id !== job?.created_by?._id ? (
                                job.created_by_me &&
                                userInfo?.role === "candidate" ? (
                                  <span
                                    style={{
                                      color: "#4CAF50",
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                      marginLeft: "8px",
                                    }}
                                  >
                                    <>
                                      {userInfo?.role === "candidate" && (
                                        <CheckCircleOutlineIcon
                                          style={{
                                            verticalAlign: "middle",
                                            marginRight: "4px",
                                            fontSize: "16px",
                                          }}
                                        />
                                      )}
                                      <span>Applied</span>
                                    </>
                                  </span>
                                ) : (
                                  userInfo.role === "candidate" && (
                                    <button
                                      className="small-button-contain-job"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenDetail(job, e);
                                      }}
                                      style={{
                                        padding: "6px 8px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        marginLeft: "8px",
                                      }}
                                    >
                                      Apply Job
                                    </button>
                                  )
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div> */}

                        <JobListCard
                          job={job}
                          setJobsList={setCategories}
                          handleCompanyNameClick={handleCompanyNameClick}
                          handlePageMove={handleOpenDetail}
                          isMobile={isMobile}
                          MENU_OPTIONS={MENU_OPTIONS}
                          handleBookmarkToggle={handleBookmarkToggle}
                          isTablet={isTabletOrAbove}
                          handleCandidates={handleCandidates}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid mt-2">
          <div className="row">
            <div className="">
              <div className="main-heading-live-jobs jobs-live-main">
                <div className="d-flex justify-content-between heading-main">
                  <h3 className="ml-4">{pageTitle} </h3>
                  <div className="d-flex gap-2">
                    <div className="custom-input-design">
                      {/* <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Search by Job Title, Description"
                        value={searchInputValue}
                        onChange={handleInputChange}
                        sx={{ minWidth: 300, flexGrow: 1 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ fontSize: 21 }} />
                            </InputAdornment>
                          ),
                          sx: {
                            "& input::placeholder": {
                              color: "#b0b0b0",
                              opacity: 1,
                            },
                          },
                        }}
                      /> */}
                      <div className="position-relative">
                        <input
                          className="ps-5"
                          placeholder={"Search..."}
                          value={searchInputValue}
                          onChange={handleInputChange}
                        />

                        <img
                          src={search_blue_icon}
                          className="input-start-icon"
                          alt=""
                        />
                      </div>
                    </div>

                    {isFavourite === true && filteredData?.length > 0 && (
                      <TextField
                        select
                        label="Filter by Source"
                        value={selectedFilter || ""}
                        onChange={(e) => handleFilterChange(e)}
                        size="small"
                        sx={{ minWidth: 200, marginRight: 2, fontSize: 14 }}
                      >
                        {filteredData.map((item) => (
                          <MenuItem
                            key={item?.source_slug}
                            value={item?.source_slug}
                            sx={{ fontSize: 14 }}
                          >
                            {item?.title}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}

                    {isLiveJobFeed && (
                      <img
                        className="hover-primary"
                        onClick={handleFilterDrawerOpen}
                        src={filter_blue_icon}
                        alt=""
                      />
                    )}

                    {(userInfo?.role === "client" ||
                      userInfo?.isCompanyProfile) &&
                      isMyJobPost === false && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handlePersonalJob}
                          >
                            My Job Posts
                          </button>
                        </>
                      )}

                    {(GetAccessOfCompany("job?.add") ||
                      GetAccessOfCompany("job?.update")) &&
                      isMyJobPost == true && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleMoveToSettings}
                          >
                            Job Settings
                          </button>
                        </>
                      )}

                    {((userInfo?.role === "client" &&
                      !userInfo?.isCompanyProfile) ||
                      (userInfo?.isCompanyProfile &&
                        userInfo?.company_access?.job?.add)) &&
                      isMyJobPost === false && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={() => {
                              navigate(`/${sourceSlug}/post-new-job`);
                              handleOpen();
                            }}
                          >
                            <PostAddOutlinedIcon className="post-add-icon" />
                            Post Job
                          </button>
                        </>
                      )}
                    {userInfo?.role === "candidate" &&
                      isFavourite === false &&
                      sourceSlug &&
                      !userInfo?.isCompanyProfile && (
                        <>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleNavigateJobAlerts}
                          >
                            <NotificationsNoneIcon
                              style={{
                                fontSize: "18px",
                                color: "#fff",
                              }}
                            />{" "}
                            Job Alerts
                          </button>
                          <button
                            className="small-button-contain-job-live"
                            onClick={handleNavigateAppliedJobs}
                          >
                            <CheckCircleOutlineIcon
                              style={{
                                fontSize: "18px",
                                color: "#fff",
                              }}
                            />{" "}
                            Applied Jobs
                          </button>
                        </>
                      )}
                  </div>
                </div>

                {Object.values(appliedFilters).some(Boolean) && (
                  <Box className="mt-3" display="flex" flexWrap="wrap" gap={1}>
                    {renderFilterChips()}
                    <Chip
                      label="Clear All"
                      onDelete={handleFilterClear}
                      color="error"
                      sx={{
                        backgroundColor: "rgba(192, 204, 250, 0.39)",
                        color: "#000",
                      }}
                    />
                  </Box>
                )}
                {loading ? (
                  <div className="mt-3 px-3">
                    <SkeletonLoader />
                  </div>
                ) : (
                  <div
                    className="mt-3 overflow-visible"
                    ref={scrollRef}
                    style={{
                      // height: isFavourite ? "" : "calc(100vh - 88px)",
                      overflowY: "auto",
                      WebkitOverflowScrolling: "touch",
                      paddingBottom: isFavourite ? "5px " : "0px",
                    }}
                    onMouseEnter={
                      !isMyJobPost ? () => setIsHovered(true) : undefined
                    }
                    onMouseOver={
                      !isMyJobPost ? () => setIsHovered(true) : undefined
                    }
                    onMouseLeave={
                      !isMyJobPost ? () => setIsHovered(false) : undefined
                    }
                  >
                    <Box className="row">
                      {categories.length > 0 ? (
                        categories.map((job, index) => (
                          <div key={index} className={`col-12`}>
                            {/* <CardContent className="pt-0">
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <Box
                                      sx={{
                                        width: 54,
                                        height: 54,
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "#fff",
                                        transition: "none",
                                        "&:hover": {
                                          boxShadow: "0 0 0 2px #e5e5e5",
                                        },
                                      }}
                                    >
                                      <Avatar
                                        src={
                                          s3baseUri +
                                          job?.created_by?.profile_image
                                            ?.thumbnail_1
                                        }
                                        onClick={(e) =>
                                          handleCompanyNameClick(job, e)
                                        }
                                        alt={job?.created_by?.company_name}
                                        style={{
                                          width: 50,
                                          height: 50,
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>

                                    <Box sx={{ ms: 2 }}>
                                      <div className="d-flex">
                                        <Typography
                                          onClick={(e) =>
                                            handleOpenDetail(job, e)
                                          }
                                          variant="h6"
                                          fontWeight="bold"
                                          sx={{ cursor: "pointer" }}
                                        >
                                          {job.job_title}{" "}
                                        </Typography>
                                      </div>

                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                      >
                                        <span
                                          className="company-name"
                                          onClick={(e) =>
                                            handleCompanyNameClick(job, e)
                                          }
                                        >
                                          {job.created_by?.company_name && (
                                            <>{job.created_by?.company_name}</>
                                          )}
                                        </span>{" "}
                                        • {job.location} •{" "}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                          }}
                                        >
                                          {moment(job.createdAt).fromNow()}
                                        </span>
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <div className="d-flex align-items-center responsive-chip-icons">
                                    {job.created_by?._id === userInfo?._id && (
                                      <Chip
                                        className="mui-chip"
                                        label="My Job"
                                        variant="outlined"
                                        color="primary"
                                      />
                                    )}
                                    {userInfo?.role === "candidate" && (
                                      <IconButton
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleBookmarkToggle(job?._id);
                                        }}
                                        sx={{
                                          paddingRight: "3px !important",
                                          paddingTop: "2px !important",
                                          paddingBottom: "0px !important",
                                        }}
                                      >
                                        {job.is_favourite ? (
                                          <BookmarkIcon
                                            className="responsive-icon"
                                            sx={{
                                              color:
                                                "var(--portal-primary-color)",
                                              padding: "0px !important",
                                            }}
                                          />
                                        ) : (
                                          <BookmarkBorderIcon
                                            className="responsive-icon"
                                            style={{
                                              padding: "0px !important",
                                            }}
                                          />
                                        )}
                                      </IconButton>
                                    )}

                                    {job?.created_by?._id === userInfo?._id && (
                                      <div onClick={(e) => e.stopPropagation()}>
                                        <CustomPopoverSection
                                          menu={MENU_OPTIONS.map((option) => ({
                                            ...option,
                                            disabled: option.getDisabled
                                              ? option.getDisabled(job)
                                              : false,
                                            tooltip: option.getTooltip
                                              ? option.getTooltip(job)
                                              : "",
                                          }))}
                                          data={job}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Box>
                                <div className="mt-2">
                                  <JobPostDescription
                                    job={job}
                                    handleOpenDetail={handleOpenDetail}
                                  />
                                </div>

                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  mt={2}
                                >
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    gap={1}
                                    flexWrap="wrap"
                                  >
                                    <Chip
                                      className="mui-chip"
                                      label={job.job_type?.title}
                                      variant="outlined"
                                    />
                                    <Chip
                                      className="mui-chip"
                                      label={show_des_data(
                                        job?.experience_required?.title
                                      )}
                                      variant="outlined"
                                    />
                                    <Chip
                                      className="mui-chip"
                                      label={formatEducationRequired(
                                        job?.education_required?.title
                                      )}
                                      variant="outlined"
                                    />
                                    {job.salary_type === "range" ? (
                                      <>
                                        <Chip
                                          variant="outlined"
                                          className="mui-chip"
                                          label={`Min Salary: €${addCommasToNumber(
                                            job.min_salary
                                          )}/${
                                            job.frequency_salary
                                              ? job.frequency_salary.toLowerCase()
                                              : ""
                                          }`}
                                          onClick={(e) =>
                                            handleOpenDetail(job, e)
                                          }
                                          sx={{ cursor: "pointer" }}
                                        />
                                        <Chip
                                          className="mui-chip"
                                          variant="outlined"
                                          label={`Max Salary: €${addCommasToNumber(
                                            job.max_salary
                                          )}/${
                                            job.frequency_salary
                                              ? job.frequency_salary.toLowerCase()
                                              : ""
                                          }`}
                                          onClick={() => handleOpenDetail(job)}
                                        />
                                      </>
                                    ) : job.salary_type === "fixed" ? (
                                      <Chip
                                        className="mui-chip"
                                        variant="outlined"
                                        label={`Fixed Salary: €${addCommasToNumber(
                                          job.salary
                                        )}/${
                                          job.frequency_salary
                                            ? job.frequency_salary.toLowerCase()
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                      />
                                    ) : null}
                                  </Box>

                                  <div className="d-flex align-items-center">
                                    {job?.created_by?._id === userInfo?._id &&
                                      userInfo?.role === "client" && (
                                        <div className="position-relative">
                                          <div
                                            className="badge position-absolute"
                                            style={{
                                              top: "-7px",
                                              right: "2px",
                                              backgroundColor: "#FF0000",
                                              color: "#fff",
                                              padding: "2px 6px",
                                              borderRadius: "12px",
                                              minWidth: "20px",
                                              textAlign: "center",
                                              fontSize: "12px",
                                              lineHeight: "1.2",
                                            }}
                                          >
                                            {job?.applicant_count || 0}
                                          </div>
                                          <button
                                            style={{ width: "125px" }}
                                            onClick={(e) => {
                                              e.stopPropagation(); // ⚠️ Prevent Card's onClick
                                              handleCandidates(job);
                                            }}
                                            className="small-button-contain-job me-2"
                                          >
                                            View Candidates
                                          </button>
                                        </div>
                                      )}

                                    {userInfo?._id !== job?.created_by?._id &&
                                      (job.applied_status
                                        ? userInfo.role === "candidate" && (
                                            <span className="me-2 mt-1">
                                              <CheckCircleOutlineIcon
                                                style={{
                                                  color: "#4CAF50",
                                                  marginRight: "2px",
                                                }}
                                              />
                                              Applied
                                            </span>
                                          )
                                        : userInfo?.role === "candidate" && (
                                            <button
                                              onClick={(e) =>
                                                handleOpenDetail(job, e)
                                              }
                                              className="small-button-contain-job"
                                            >
                                              Apply Job
                                            </button>
                                          ))}

                                    {userInfo?._id === job.created_by?._id && (
                                      <button
                                        onClick={(e) =>
                                          handleOpenDetail(job, e)
                                        }
                                        className="small-button-contain-job"
                                      >
                                        View Detail
                                      </button>
                                    )}
                                  </div>
                                </Box>
                              </CardContent> */}

                            <JobListCard
                              job={job}
                              setJobsList={setCategories}
                              handleCompanyNameClick={handleCompanyNameClick}
                              handlePageMove={handleOpenDetail}
                              isMobile={isMobile}
                              MENU_OPTIONS={MENU_OPTIONS}
                              handleBookmarkToggle={handleBookmarkToggle}
                              isTablet={isTabletOrAbove}
                              handleCandidates={handleCandidates}
                            />
                          </div>
                        ))
                      ) : (
                        <div>
                          <RecordNotFound title="No jobs" />
                        </div>
                      )}
                      <div className="mb-5">
                        <CustomPagination
                          totalPages={totalPages}
                          page={pageNumber}
                          onPageChange={(value) => {
                            loadMoreData("multi_page", value);
                          }}
                        />
                      </div>
                      {/* {totalPages >= pageNumber ? (
                        <div className="col-12 text-center mt-3">
                          <span
                            ref={lastBookElementRef ? lastBookElementRef : null}
                            className="mt-3"
                            onClick={loadMoreData}
                            id="load-more-feed"
                          >
                            {isLoadingMore ? (
                              <CircularProgress color="primary" size="1.5rem" />
                            ) : (
                              "Load More"
                            )}
                          </span>
                        </div>
                      ) : (
                        ""
                      )} */}
                    </Box>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomDrawer
        isOpenDrawer={filterDrawerOpen}
        onCloseDrawer={handleFilterDrawerClose}
        pageTitle="Filter Jobs"
        componentToPassDown={
          <JobsFilter
            onCloseDrawer={handleFilterDrawerClose}
            selectedObject={null}
            refreshList={fetchCategories}
            memberList={categories}
            applyFilters={applyFilters}
            handleFilterChange={handleFilterChange}
            filterValues={filterValues}
            handleFilterClear={handleFilterClear}
          />
        }
      />
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this job?"}
        headerHeading={"Delete Job"}
        handleAgree={() => handleDeleteMember(deletingMemberId)}
      />
    </>
  );
}
